<template>
  <b2b-aside v-model="isActive" class="b2b-filter-tags" left>
    <template v-if="!hideActivator" #activator>
      <div class="b2b-filter-tags__chips">
        <template v-for="tag in selectedTags">
          <b2b-chip :key="tag.id" v-text="tag.descricao" @click:close="$_onClickTagClose(tag.id)" />
        </template>
      </div>
    </template>

    <template #title>
      <h1 class="pa--3" v-text="$t('labels.filters')" />
    </template>

    <b2b-list>
      <template v-for="tagType in tagTypes">
        <b2b-list-expandable :key="tagType.id" :value="true">
          <b2b-list-item-title v-text="tagType.descricao" />

          <template #expand>
            <template v-for="tag in tags[tagType.id]">
              <b2b-checkbox
                v-model="$_model"
                :key="tag.id"
                :value="tag.id"
                :label="tag.descricao"
                @change="$_onInputCheckbox($event, tag)" />
            </template>

            <b2b-button dense
              v-text="$t('labels.show-more')"
              class="b2b-filter-tags__more my--3"
              @click="$_onClickMore(tagType)" />
          </template>
        </b2b-list-expandable>
      </template>
    </b2b-list>

    <template #actions>
      <b2b-grid-row class="b2b-filter-tags__actions px--2">
        <b2b-button
          block
          dense
          flat
          :disabled="$_model.length === 0"
          v-text="$t('labels.tags.clear-all')"
          @click.stop="$_clear"
        />
        <b2b-button block dense v-text="$t('labels.apply')" @click.stop="$_apply" />
      </b2b-grid-row>
    </template>

    <b2b-dialog-tags
      v-model="$_model"
      :title="dialog.title"
      :tag-type-id="dialog.tagTypeId"
      :active.sync="dialog.show"
      @change="({ $event, $tag }) => $_onInputCheckbox($event, $tag)" />
  </b2b-aside>
</template>

<script>
import ActivableMixin from '../../mixins/base/activable-mixin';
import ModelMixin from '../../mixins/base/model-mixin';

import ActionResolver from '../../mixins/action-resolver';

import B2bAside from '../core/b2b-aside.vue';
import B2bChip from '../core/b2b-chip.vue';

import B2bList from '../core/list/b2b-list.vue';
import B2bListExpandable from '../core/list/b2b-list-expandable.vue';
import B2bListItemTitle from '../core/list/b2b-list-item-title.vue';
import B2bCheckbox from '../core/form/b2b-checkbox.vue';
import B2bGridRow from '../core/grid/b2b-grid-row.vue';
import B2bButton from '../core/buttons/b2b-button.vue';

import B2bDialogTags from '../dialogs/b2b-dialog-tags.vue';

export default {
  name: 'b2b-filter-tags',

  mixins: [
    ActivableMixin('active'),

    ModelMixin(Array),

    ActionResolver(),
  ],

  components: {
    B2bAside,
    B2bChip,

    B2bList,
    B2bListExpandable,
    B2bListItemTitle,
    B2bCheckbox,
    B2bGridRow,
    B2bButton,

    B2bDialogTags,
  },

  props: {
    hideActivator: Boolean,
  },

  data() {
    return {
      dialog: {
        show: false,
        title: null,
        tagTypeId: null,
      },

      loadingTags: false,
      tagsLoaded: false,
      tagTypes: [],
      tags: {},
      selectedTags: [],
    };
  },

  methods: {
    open() {
      this.isActive = true;
    },

    $_clear() {
      this.$_model = [];
      this.selectedTags = [];
    },

    $_apply() {
      this.isActive = false;
    },

    $_onInputCheckbox($event, tag) {
      if ($event.includes(tag.id)) {
        this.selectedTags.push(tag);
      } else {
        this.selectedTags = this.selectedTags.filter(({ id }) => id !== tag.id);
      }
    },

    $_ensureTagsLoaded() {
      if (this.tagsLoaded || this.loadingTags) return Promise.resolve();

      this.loadingTags = true;

      return this.$_actionResolver({
        action: 'tag-types/index',
        params: { 'tipoAgrupamentos.recurso': 'produtos' },
      })
        .then(({ items: tagTypes = [] } = {}) => {
          this.tagTypes = tagTypes;

          return Promise.all(tagTypes.map((item) => this.$_loadTagsFromTagType(item.id, 5)
            .then(({ items: tags = [] } = {}) => {
              this.$set(this.tags, item.id, tags);
            })));
        })
        .then(() => {
          this.tagsLoaded = true;
        })
        .finally(() => {
          this.loadingTags = false;
        });
    },

    $_loadTagsFromTagType(tagTypeId, limit) {
      return this.$_actionResolver({
        action: 'tags/index',
        params: { limit, 'agrupamentos.tipoAgrupamentoId': tagTypeId },
      });
    },

    $_onClickTagClose(tagId) {
      this.$_model = this.$_model.filter((id) => id !== tagId);
      this.selectedTags = this.selectedTags.filter(({ id }) => id !== tagId);
    },

    $_onClickMore(tagType) {
      this.dialog.tagTypeId = tagType.id;
      this.dialog.title = tagType.descricao;

      this.$nextTick(() => {
        this.dialog.show = true;
      });
    },
  },
};
</script>

<style lang="scss">
.b2b-filter-tags {
  &__chips {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    margin: 0 -8px;
  }

  &__more {
    margin-right: 48px;
  }

  &__actions {
    gap: 8px;
  }
}

@media (max-width: 410px) {
  .b2b-aside__wrap {
    max-width: calc(100% - 20px) !important;
  }

  .b2b-aside__actions .px--2 {
    padding: 0 !important;
  }
}

@media (max-width: 320px) {
  .b2b-button {
    font-size: 13px !important;
  }
}
</style>
